<template>
  <div class="product-list">
    <van-checkbox-group v-model="result" v-if="isCheck">
      <div class="item" v-for="value in datas" :key="value.goods_id">
        <van-checkbox :name="value"></van-checkbox>
        <van-image :src="value[props.url]"></van-image>
        <div class="right-region">
          <p v-html="value[props.name]"></p>
          <p>
            <span v-if="value[props.spec]">规格 {{value[props.spec]}}<i v-if="value[props.suggestPrice]">|</i></span>
            <!-- <span v-if="value[props.per]">起订 {{value[props.per]}}<i>|</i></span> -->
            <span v-if="value[props.suggestPrice]">建议零售 ￥{{value[props.suggestPrice]}}</span>
          </p>
          <p v-if="value[props.dailyLimitNum]" class="limit-text">每日限购 {{value[props.dailyLimitNum]}} 件</p>
          <div class="bottom">
            <div>
              <p>￥{{value[props.price]}}</p>
              <p>{{formatMinLimitText(value)}}</p>
            </div>
            <van-stepper :value="formatStepperNumber(value[props.number])" async-change @plus="plus(value)" @minus="minus(value)" min="0" disable-input :long-press="false"></van-stepper>
          </div>
        </div>
      </div>
    </van-checkbox-group>
    <div class="item order-item" v-for="value in datas" :key="value.goods_id" v-else-if="isOrder">
      <van-image :src="value[props.url]"></van-image>
      <div class="name">
        <p v-html="value[props.name]"></p>
        <p v-if="value[props.allowUserCoupon]">可用券</p>
      </div>
      <p><span>￥{{value[props.price]}}</span> x {{value[props.number]}}</p>
    </div>
    <div class="item cart-item" :class="{'gift-cart-item': value.is_gift}" v-for="value in datas" :key="value.is_gift ? 'gift-' + value.id : value.id" v-else-if="isCart">
      <van-image :src="value[props.url]"></van-image>
      <div class="name">
        <p class="cart-product-name">
          <span class="gift-tag" v-if="value.is_gift">满赠</span>
          <span v-html="value[props.name]"></span>
        </p>
        <p v-if="value.is_gift">满{{value.gift_min_price}}元赠送</p>
        <p v-else-if="value[props.allowUserCoupon]">可用券</p>
        <p v-if="!value.is_gift && value[props.dailyLimitNum]">每日限购 {{value[props.dailyLimitNum]}} 件</p>
      </div>
      <p v-if="!value.is_gift">￥{{value[props.price]}}</p>
      <p class="gift-price" v-else>赠品</p>
      <van-stepper v-if="!value.is_gift" :value="formatStepperNumber(value[props.number])" async-change @plus="plus(value)" @minus="minus(value)" min="0" disable-input :long-press="false"></van-stepper>
      <span class="gift-number" v-else>×{{value[props.number]}}</span>
    </div>
    <div class="item" v-for="value in datas" :key="value.goods_id" v-else>
      <div class="product-image-wrap" :class="{'is-special': value.is_special_price}">
        <van-image :src="value[props.url]"></van-image>
        <span class="special-flag" v-if="value.is_special_price">特价</span>
        <span class="special-date" v-if="value.special_activity_date_label">
          <b>限时</b>{{value.special_activity_date_label}}
        </span>
      </div>
      <div class="right-region">
        <p class="product-title" v-html="formatDisplayTitle(value[props.name])"></p>
        <p>
          <span v-if="value[props.spec]">规格 {{value[props.spec]}}<i v-if="value[props.suggestPrice]">|</i></span>
          <!-- <span v-if="value[props.per]">起订 {{value[props.per]}}<i>|</i></span> -->
          <span v-if="value[props.suggestPrice]">建议零售 ￥{{value[props.suggestPrice]}}</span>
        </p>
        <p>
          <span v-if="value[props.allowUserCoupon]">可用券</span>
          <span class="estimated_price" v-if="value[props.allowEstimatedPrice] && (value[props.estimatedPrice] != value[props.price])">￥{{value[props.estimatedPrice]}}</span>
          <span class="estimated_price_tag" v-if="value[props.allowEstimatedPrice] && (value[props.estimatedPrice] != value[props.price])">预估到手价</span>
        </p>
        <p v-if="value[props.dailyLimitNum] || isGiftExcludedSpecial(value)" class="promotion-meta">
          <span v-if="value[props.dailyLimitNum]" class="limit-text">每日限购 {{value[props.dailyLimitNum]}} 件</span>
          <span v-if="isGiftExcludedSpecial(value)" class="gift-exclusion-tag">不参与满赠</span>
        </p>
        <div class="bottom">
          <div>
            <p>￥{{value[props.price]}}</p>
            <p><i v-if="value[props.oldPrice]">￥{{value[props.oldPrice]}}</i></p>
            <p v-if="value[props.per] && !value[props.number]">{{formatMinLimitText(value)}}</p>
          </div>
          <van-stepper :value="formatStepperNumber(value[props.number])" async-change @plus="plus(value)" @minus="minus(value)" min="0" disable-input :long-press="false"></van-stepper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CommonService from '@/io/common.js';
  import { formatDisplayTitle } from '@/utils/product-title.js';
  
  export default {
    name: 'ProductList',
    props: {
      isCheck: {
        type: Boolean,
        default: false
      },
      isOrder: {
        type: Boolean,
        default: false
      },
      isCart: {
        type: Boolean,
        default: false
      },
      datas: {
        type: Array,
        default() {
          return [];
        }
      },
      props: {
        type: Object,
        default() {
          return {
            url: 'image',
            name: 'title',
            spec: 'spec',
            per: 'name_ext',
            price: 'price',
            max: 'max',
            number: 'number',
            suggestPrice: 'suggested_retail_price',
            oldPrice: 'old_price',
            dailyLimitNum: 'daily_limit_num',
            minNumLimit: 'min_num_limit',
            minNumLimitStep: 'min_num_limit_step',
            allowUserCoupon: 'allow_user_coupon',
            allowEstimatedPrice: 'allow_estimated_price',
			estimatedPrice: 'estimated_price',
          }
        }
      }
    },
    data() {
      return {
        status: false,
        result: []
      }
    },
    methods: {
      formatStepperNumber(number) {
        return number > 999 ? '999+' : number;
      },
      formatDisplayTitle(title) {
        return formatDisplayTitle(title);
      },
      isGiftExcludedSpecial(data) {
        return Boolean(data && data.is_special_price && Number(data.exclude_gift_price) === 1);
      },
      formatMinLimitText(data) {
        const minLimitText = data[this.props.per];
        if (!minLimitText) {
          return '';
        }
        const baseText = String(minLimitText).indexOf('起') >= 0 ? minLimitText : `起订 ${minLimitText}`;
        const minLimitNum = data[this.props.minNumLimit] || minLimitText;
        if (Number(data[this.props.minNumLimitStep]) === 1 && minLimitNum) {
          return `${baseText}，按${minLimitNum}件递增`;
        }
        return baseText;
      },
      plus(data) {
        if (this.status) {
          this.$notify({
            message: '拼命处理中，请稍后~',
            duration: 1000
          });
        } else {
          this.status = true;
          let merchantId = data.merchantId;
          CommonService.addCart(merchantId, data.id).then(res => {
            this.updateCartInfo(merchantId, () => {
              data.number += res.num * 1;
              // this.$store.commit('setCartTotalPrice', res.data.total_price);
              this.$emit('addCart');
            });
          }).catch(err => {
            CommonService.allInfo(true).then(() => {
              this.$emit('addCart');
            }).catch(err => {});
          }).finally(() => {
            this.status = false;
          });
        }
      },
      minus(data) {
        if (this.status) {
          this.$notify({
            message: '拼命处理中，请稍后~',
            duration: 1000
          });
        } else {
          this.status = true;
          let merchantId = data.merchantId;
          CommonService.removeCart(merchantId, data.id).then(res => {
            this.updateCartInfo(merchantId, () => {
              data.number -= res.num * 1;
              // this.$store.commit('setCartTotalPrice', res.data.total_price);
              this.$emit('removeCart');
            });
          }).catch(err => {
            CommonService.allInfo(true).then(() => {
              this.$emit('removeCart');
            }).catch(err => {});
          }).finally(() => {
            this.status = false;
          });
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .product-list {
    .item {
      display: flex;
      align-items: center;
      &.order-item {
        justify-content: space-between;
        .van-image {
          width: 100 * @r;
          height: 100 * @r;
        }
        & > p {
          margin-right: 30 * @r;
          font-size: 24 * @r;
          &:nth-of-type(1) {
            width: 15%;
            color: #AFB2B9;
            text-align: center;
            flex: 1;
            text-align: right;
            span {
              color: #F56332;
            }
          }
        }
        .name {
          flex: 1;
          margin-right: 30 * @r;
          font-size: 24 * @r;
          p {
            &:nth-of-type(n+2) {
              font-size: 20 * @r;
              opacity: .4;
            }
          }
        }
      }
      &.cart-item {
        justify-content: space-between;
        &.gift-cart-item {
          margin: 0 -12 * @r;
          padding: 16 * @r 12 * @r;
          border-radius: 10 * @r;
          background: #FFF8F3;
        }
        .van-image {
          width: 100 * @r;
          height: 100 * @r;
        }
        & > p {
          margin-right: 30 * @r;
          font-size: 24 * @r;
          &:nth-of-type(1) {
            width: 15%;
            color: #AFB2B9;
            text-align: center;
          }
        }
        .name {
          flex: 1;
          margin-right: 30 * @r;
          font-size: 24 * @r;
          min-width: 0;
          .cart-product-name {
            display: flex;
            align-items: center;
            .gift-tag {
              flex-shrink: 0;
              margin-right: 8 * @r;
              padding: 3 * @r 8 * @r;
              border-radius: 5 * @r;
              background: @color-primary;
              color: #fff;
              font-size: 18 * @r;
              font-weight: 500;
              line-height: 1.3;
            }
            & > span:last-child {
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          p {
            &:nth-of-type(n+2) {
              font-size: 20 * @r;
              opacity: .4;
            }
          }
        } 
        .van-stepper {
          flex-shrink: 0;
        }
        .gift-price {
          width: auto;
          color: @color-primary;
          font-weight: 500;
          white-space: nowrap;
        }
        .gift-number {
          flex-shrink: 0;
          color: #666;
          font-size: 24 * @r;
        }
      }
      & + .item {
        margin-top: 16 * @r;
      }
      &:not(:last-of-type) {
        border-bottom: 1px solid #EBEBEB;
        padding-bottom: 16 * @r;
      }
      .van-checkbox {
        margin-right: 38 * @r;
      }
      .van-image {
        width: 160 * @r;
        height: 160 * @r;
        margin-right: 30 * @r;
      }
      .product-image-wrap {
        position: relative;
        flex: 0 0 152 * @r;
        width: 152 * @r;
        height: 152 * @r;
        margin-right: 24 * @r;
        overflow: hidden;
        border-radius: 8 * @r;
        .van-image {
          width: 100%;
          height: 100%;
          margin-right: 0;
        }
        &.is-special .van-image {
          position: absolute;
          top: 32 * @r;
          left: 50%;
          width: 124 * @r;
          height: 92 * @r;
          transform: translateX(-50%);
          /deep/ img {
            object-fit: contain;
          }
        }
        .special-flag {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          padding: 7 * @r 11 * @r 10 * @r;
          border-radius: 0 0 22 * @r 0;
          background: linear-gradient(135deg, #34d07f, #16b96a);
          color: #fff;
          font-size: 20 * @r;
          font-weight: 700;
          line-height: 1;
        }
        .special-date {
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 1;
          display: flex;
          align-items: center;
          min-height: 28 * @r;
          padding-right: 6 * @r;
          background: linear-gradient(90deg, rgba(255, 240, 179, .98), rgba(255, 249, 221, .94));
          color: #4b4b4b;
          font-size: 17 * @r;
          font-weight: 700;
          white-space: nowrap;
          b {
            align-self: stretch;
            display: flex;
            align-items: center;
            margin-right: 6 * @r;
            padding: 0 6 * @r;
            background: #f35d3c;
            color: #fff;
            font-weight: 700;
          }
        }
      }
      .right-region {
        flex: 1;
        min-width: 0;
        & > p {
          display: flex;
          span {
            display: flex;
          }
          &:nth-of-type(1) {
            font-size: 24 * @r;
            margin-bottom: 12 * @r;
          }
          &:nth-of-type(2),
          &:nth-of-type(3) {
            font-size: 22 * @r;
            color: #AFB2B9;
            margin-bottom: 10 * @r;
          }
          &.promotion-meta {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            column-gap: 8 * @r;
            margin-bottom: 10 * @r;
            .limit-text {
              color: @color-primary;
              font-size: 21 * @r;
              white-space: nowrap;
            }
            .gift-exclusion-tag {
              flex-shrink: 0;
              padding: 4 * @r 9 * @r;
              border-radius: 14 * @r;
              background: #fff1e8;
              color: #d75a30;
              font-size: 19 * @r;
              font-weight: 500;
              line-height: 1.2;
              white-space: nowrap;
            }
          }
          i {
            color: #F56332;
            margin: 0 8 * @r;
          }
		  .estimated_price {
			  line-height: 18px;
			  font-size: 12px;
			  color: #F56332;
		  }
		  .estimated_price_tag {
			  margin-left: 5px;
			  background-color: #fdeeef;
			  color: #f33f4d;
			  border-radius: 4px;
			  padding: 1px 4px;
		  }
        }
        .product-title {
          display: -webkit-box;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          line-height: 1.35;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          & > div {
            display: flex;
            align-items: center;
            & > p {
              &:nth-of-type(1) {
                font-size: 34 * @r;
                font-weight: 700;
                line-height: 1.2;
                color: @color-primary;
                margin-right: 10 * @r;
              }
              &:nth-of-type(2) {
                font-size: 24 * @r;
                font-weight: 500;
                opacity: .4;
                text-decoration: line-through;
                margin-right: 20 * @r;
              }
              &:nth-of-type(3) {
                font-size: 22 * @r;
                opacity: .4;
              }
            }
          }
          .van-stepper {
            flex-shrink: 0;
          }
        }
      }
    }
  }
  /deep/ .van-stepper {
    flex-shrink: 0;
    .van-stepper__input {
      width: 42 * @r;
      margin: 0 8 * @r;
      font-size: 26 * @r;
    }
  }
</style>
